import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import ModalComponent from './ModalComponent';
import { bodyModalAddEvidenceFile } from '../governement_book/expedient_details/expedient_details_logic';
import {
  fieldsValidation,
  renderErrorsByInputName,
} from '../search_for_lawyers/search_lawyers_logic';
import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import Cookies from 'js-cookie';

const TableUploadManyFiles = ({
  acceptFiles,
  getFiles,
  expedientNumber,
  dataUploadEvidences,
  reloadDataComponent,
  errorsHeredated,
  isSuperPosisionated,
}) => {
  const [listOfFiles, setListOfFiles] = useState([]);
  const [fileState, setFileState] = useState({});
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const { authentication_token_02 } = Cookies.get();
  const [, setFilesTried] = useState([]);

  // The upload is triggered by `dataUploadEvidences` only, so the list is read
  // through a ref: depending on `listOfFiles` would restart the upload on every
  // status change.
  const listOfFilesRef = useRef(listOfFiles);

  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptFiles,
    onDrop: (acceptedFiles) => {
      acceptedFiles.forEach((file, index) => {
        if (!file['type'].includes('image')) {
          Object.assign(file, {
            preview: process.env.PUBLIC_URL + '/img/document.svg',
          });
        } else {
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          });
        }
        setFileState({ ...fileState, evidence_file: file });
        setErrors({
          ...errors,
          evidence_file: [],
        });
      });
    },
  });

  const deleteFile = (fileToDelete) => {
    let newFiles = [...listOfFiles];
    const indexDelete = newFiles.map((file) => file['alias']).indexOf(fileToDelete['alias']);
    if (indexDelete !== -1) {
      newFiles.splice(indexDelete, 1);
      setListOfFiles(newFiles);
      getFiles(newFiles);
    }
  };

  const addFileToTable = (fileToAdd) => {
    const requiredFields = ['evidence_type', 'alias', 'evidence_file'];
    const responseValidation = fieldsValidation(requiredFields, fileState);

    if (typeof responseValidation === 'object') {
      NotificationManager.error(
        'Existen errores que te impiden continuar, por favor revisa los campos marcados con rojo'
      );
      setErrors(responseValidation);
    } else {
      let newArr = [...listOfFiles];
      newArr.push(fileToAdd);
      setListOfFiles(newArr);
      setFileState({});
      setShow(false);
      getFiles(newArr);

      newArr.forEach((file) => {
        URL.revokeObjectURL(file['evidence_file']['preview']);
      });
    }
  };

  const getPromotionId = () =>
    dataUploadEvidences &&
    typeof dataUploadEvidences === 'object' &&
    dataUploadEvidences['promotion_id']
      ? dataUploadEvidences['promotion_id']
      : null;

  /**
   * Index of the last file the upload still has to send. Core only builds the
   * consolidated acknowledgement when it receives `lastFile`, so the flag has to
   * travel with the file that completes the set — which is not necessarily the
   * last one of the table when some of them failed and are being retried.
   */
  const lastPendingIndexOf = (files) => {
    let lastPendingIndex = -1;

    files.forEach((file, index) => {
      if (file['status'] !== 2) {
        lastPendingIndex = index;
      }
    });

    return lastPendingIndex;
  };

  const notifyAcknowledgement = (acknowledgement) => {
    if (!acknowledgement || typeof acknowledgement !== 'object' || acknowledgement['sent']) {
      return;
    }

    const message =
      acknowledgement['message'] ||
      'No fue posible enviar el acuse de la promoción por correo electrónico.';

    if (acknowledgement['reason'] === 'pending_annexes') {
      NotificationManager.warning(message, 'Acuse pendiente', 10000);
      return;
    }

    NotificationManager.error(message, 'Acuse no enviado', 10000);
  };

  const executeFilesUploading = async () => {
    const promotionId = getPromotionId();

    if (!promotionId) {
      NotificationManager.error(
        'No se encontró el identificador de la promoción, por lo que no se subieron los anexos'
      );
      return;
    }

    const currentFiles = listOfFilesRef.current;

    if (currentFiles.length === 0) {
      return;
    }

    const filesToUpload = currentFiles.map((file) => ({
      ...file,
      status: file['status'] === 2 ? 2 : 1,
    }));

    setListOfFiles(filesToUpload);

    const lastPendingIndex = lastPendingIndexOf(filesToUpload);
    const uploadedFiles = [];

    for (let index = 0; index < filesToUpload.length; index++) {
      const file = filesToUpload[index];

      const result = await uploadDocument(
        file,
        promotionId,
        index === lastPendingIndex,
        filesToUpload.length
      );

      const updatedFile = {
        ...file,
        status: result['error'] ? 3 : 2,
      };

      uploadedFiles.push(updatedFile);

      setListOfFiles((files) =>
        files.map((currentFile, currentIndex) =>
          currentIndex === index ? updatedFile : currentFile
        )
      );

      notifyAcknowledgement(result['acknowledgement']);
    }

    setFilesTried(uploadedFiles);
  };

  const uploadDocument = async (file, promotionId, isLastFile, totalFiles) => {
    if (file['status'] === 2) {
      return {
        error: false,
        status: 2,
        message: 'Archivo subido correctamente',
        file: file,
      };
    }

    if (!promotionId) {
      return {
        error: true,
        status: 3,
        message: 'No se encontró el identificador de la promoción',
        file: file,
      };
    }

    try {
      const filedata = new FormData();

      filedata.append('annexed_type', file['evidence_type']);
      filedata.append('alias', file['alias']);
      filedata.append('evidence_file', file['evidence_file']);
      filedata.append('promotion_id', promotionId);
      filedata.append('document_type', file['evidence_type']);
      filedata.append('lastFile', isLastFile ? '1' : '0');
      filedata.append('totalFiles', totalFiles);

      const responseDocumentSave = await axios({
        method: 'post',
        url:
          process.env.REACT_APP_URL_API_LARAVEL +
          '/document_expedients/evidences/upload/' +
          expedientNumber,
        data: filedata,
        headers: authentication_token_02
          ? {
              Authorization: String(authentication_token_02),
            }
          : {},
      });

      const responseData =
        responseDocumentSave && responseDocumentSave.data && responseDocumentSave.data.data;

      const evidenceDocument = responseData && responseData.evidenceDocument;

      if (evidenceDocument && typeof evidenceDocument === 'object') {
        return {
          error: false,
          status: 2,
          message: 'Archivo subido correctamente',
          file: file,
          acknowledgement: responseData.acknowledgement,
        };
      }

      return {
        error: true,
        status: 3,
        message: 'La subida del archivo falló',
        file: file,
      };
    } catch (error) {
      console.error('Error al subir evidencia:', error);

      return {
        error: true,
        status: 3,
        message: 'La subida del archivo falló',
        file: file,
      };
    }
  };

  const uploadAgain = async (fileAgain) => {
    const promotionId = getPromotionId();

    if (!promotionId) {
      NotificationManager.error('No se encontró el identificador de la promoción');
      return;
    }

    const currentFiles = listOfFilesRef.current;
    const index = currentFiles.findIndex((file) => file === fileAgain);

    if (index === -1) {
      return;
    }

    // A retry that leaves no other annex pending is the one that completes the
    // promotion, so it has to carry the flag core waits for to send the acuse.
    const isLastFile = index === lastPendingIndexOf(currentFiles);

    setListOfFiles((files) =>
      files.map((file, currentIndex) =>
        currentIndex === index
          ? {
              ...file,
              status: 1,
            }
          : file
      )
    );

    const result = await uploadDocument(fileAgain, promotionId, isLastFile, currentFiles.length);

    setListOfFiles((files) =>
      files.map((file, currentIndex) =>
        currentIndex === index
          ? {
              ...file,
              status: result['error'] ? 3 : 2,
            }
          : file
      )
    );

    notifyAcknowledgement(result['acknowledgement']);
  };

  useEffect(() => {
    listOfFilesRef.current = listOfFiles;
  }, [listOfFiles]);

  useEffect(() => {
    // Null until the promotion itself has been submitted: there is nothing to
    // upload — and nothing to report — before that.
    if (!dataUploadEvidences || typeof dataUploadEvidences !== 'object') {
      return;
    }

    executeFilesUploading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUploadEvidences]);

  useEffect(() => {
    (async function () {
      const existsFilesErrors = listOfFiles.filter((file) => {
        return file['status'] === 3 || !file['status'];
      });

      if (
        existsFilesErrors.length === 0 &&
        typeof dataUploadEvidences === 'object' &&
        dataUploadEvidences &&
        dataUploadEvidences['promotion_id']
      ) {
        await reloadDataComponent(
          'La subida del documento y sus archivos de prueba ha sido exitosa',
          'Excelente',
          5000
        );
      }
    })();
  }, [listOfFiles]);

  return (
    <>
      <section className="container">
        <div style={{ float: 'right' }}>
          <Button
            onClick={() => setShow(true)}
            style={{
              fontWeight: 'bold',
              fontSize: '14px',
              backgroundColor: '#02cc98',
            }}
            size="md"
            variant="outline-light"
          >
            <strong>
              <i className="fas fa-plus" /> Agregar anexo
            </strong>
          </Button>
          {renderErrorsByInputName(errorsHeredated, 'evidence_file')}
        </div>
        <div className="clearFloat" />
        <div className="mT-20" style={{ overflowX: 'scroll' }}>
          {listOfFiles.length > 0 ? (
            <table
              className="table table-collapsed"
              style={{
                border: '1px solid #a2a2a2',
                marginTop: '10px',
              }}
            >
              <tbody>
                <tr style={{ backgroundColor: '#02cc98' }}>
                  <th className="text-center button-see-evidence-documents">Documento:</th>
                  <th className="text-center button-see-evidence-documents">Tipo:</th>
                  <th className="text-center button-see-evidence-documents">Etiqueta:</th>
                  <th className="text-center button-see-evidence-documents">Acciones:</th>
                </tr>
                {listOfFiles.map((file, index) => (
                  <tr key={index}>
                    <td style={{ paddingTop: '15px' }} className="text-center">
                      {file['status'] === 1 ? (
                        <>
                          <img
                            width="40px"
                            src={process.env.PUBLIC_URL + '/img/loader.gif'}
                            alt="Cargando archivo"
                          />
                          <br />
                          <small>Subiendo archivo...</small>
                        </>
                      ) : file['status'] === 2 ? (
                        <>
                          <i className="fas fa-check-circle" style={{ color: 'green' }} />
                          <br />
                          <small>El archivo se subió correctamente</small>
                        </>
                      ) : file['status'] === 3 ? (
                        <>
                          <i className="fas fa-exclamation-triangle" style={{ color: 'red' }} />
                          <br />
                          <small style={{ fontSize: '8px' }}>La carga del archivo falló</small>
                          <br />
                          <Button
                            size="sm"
                            variant="info"
                            title="Reintentar"
                            style={{ fontSize: '10px' }}
                            onClick={() => uploadAgain(file)}
                          >
                            <i
                              className="fas fa-cloud-upload-alt"
                              style={{ color: 'white', fontSize: '10px' }}
                            />{' '}
                            Reintentar
                          </Button>
                        </>
                      ) : (
                        index + 1
                      )}
                    </td>
                    <td style={{ paddingTop: '15px', maxWidth: '150px' }} className="text-center">
                      {file['evidence_type']}
                    </td>
                    <td style={{ paddingTop: '15px', maxWidth: '150px' }} className="text-justify">
                      {file['alias']}
                    </td>
                    <td style={{ paddingTop: '10px' }} className="text-center">
                      <Button
                        size="sm"
                        variant="danger"
                        title="Cancelar"
                        onClick={() => deleteFile(file)}
                      >
                        <i className="ti-trash" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            ''
          )}
        </div>
        <div className="clearFloat mT-10" />
        <small className="text-justify">
          * IMPORTANTE: Para agregar un anexo o prueba, haz clic en el botón{' '}
          <strong>Agregar anexo </strong>y proporciona la información solicitada por cada documento
          a subirse.
        </small>
      </section>

      <div className={show && isSuperPosisionated ? 'modal-superpositionated-fade' : 'd-n'} />
      <ModalComponent
        header={'Carga de anexo'}
        show={show}
        onHide={setShow}
        canClose={true}
        scroll={false}
        body={bodyModalAddEvidenceFile(
          setFileState,
          fileState,
          getRootProps,
          errors,
          setErrors,
          getInputProps
        )}
        footer={
          <>
            <Button variant="secondary" onClick={() => setShow(false)}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={() => addFileToTable(fileState)}>
              Agregar
            </Button>
          </>
        }
      />
    </>
  );
};

export default TableUploadManyFiles;
